export type Product = {
  id: string;
  vendor: string;
  title: string;
  price: string;
  image: string;
  href: string;
  soldOut?: boolean;
};

export const featuredProducts: Product[] = [
  {
    id: "14-karat-yellow-gold-spike-band-with-diamonds",
    vendor: "costar",
    title: "14 Karat Yellow Gold Spike Band with Diamonds",
    price: "$2,000",
    image:
      "https://sofiajewelry.com/cdn/shop/files/R15678YB-1.jpg?v=1778712196",
    href: "/product/14-karat-yellow-gold-spike-band-with-diamonds",
  },
  {
    id: "14-karat-white-gold-inside-out-with-black-diamonds",
    vendor: "DILAMANI",
    title: "14 Karat White Gold Inside out with Black Diamonds",
    price: "$1,900",
    image:
      "https://sofiajewelry.com/cdn/shop/files/AE19703BL-600W-1.jpg?v=1775067494",
    href: "/product/14-karat-white-gold-inside-out-with-black-diamonds",
  },
  {
    id: "sterling-silver-round-cassi-disc-pendant",
    vendor: "Suneera",
    title: "Sterling Silver Round CASSI 20mm Disc Pendant with Scattered White Diamonds",
    price: "$1,150",
    image:
      "https://sofiajewelry.com/cdn/shop/files/CASSI-P-1.jpg?v=1765476712",
    href: "/product/sterling-silver-round-cassi-disc-pendant",
  },
  {
    id: "14-karat-yellow-gold-band-with-diamonds",
    vendor: "costar",
    title: "14 Karat Yellow Gold Band with Diamonds",
    price: "$3,750",
    image:
      "https://sofiajewelry.com/cdn/shop/files/R15625YB-1.jpg?v=1778712073",
    href: "/product/14-karat-yellow-gold-band-with-diamonds",
  },
  {
    id: "14-karat-yellow-gold-band-channel-set-baguette-band",
    vendor: "costar",
    title: "14 Karat Yellow Gold Band Channel Set Baguette Band",
    price: "$3,500",
    image:
      "https://sofiajewelry.com/cdn/shop/files/R15627YB-1.jpg?v=1778703713",
    href: "/product/14-karat-yellow-gold-band-channel-set-baguette-band",
  },
  {
    id: "14-karat-white-gold-blue-sapphire-marquise-band",
    vendor: "costar",
    title: "14 Karat White Gold Band with Blue Sapphire Marquise and Diamonds",
    price: "$2,000",
    image:
      "https://sofiajewelry.com/cdn/shop/files/R13964WB-BS-1_58f222de-8ede-48ec-8afa-e27d7adbfb9e.jpg?v=1778702948",
    href: "/product/14-karat-white-gold-blue-sapphire-marquise-band",
  },
  {
    id: "14-karat-white-gold-diamond-baguette-channel-band",
    vendor: "costar",
    title: "14 Karat White Gold Diamond Baguette Channel Band",
    price: "$5,250",
    image:
      "https://sofiajewelry.com/cdn/shop/files/R15535WB100-1.jpg?v=1778702799",
    href: "/product/14-karat-white-gold-diamond-baguette-channel-band",
  },
  {
    id: "14-karat-yellow-gold-horseshoe-stud-earrings",
    vendor: "DILAMANI",
    title: "14 Karat Yellow Gold Horseshoe Stud Earrings with Diamonds",
    price: "$710",
    image:
      "https://sofiajewelry.com/cdn/shop/files/AE81352D-800Y-1.jpg?v=1774999445",
    href: "/product/14-karat-yellow-gold-horseshoe-stud-earrings",
    soldOut: true,
  },
];

export const lookProducts: Product[] = [
  {
    id: "18-karat-yellow-gold-deco-diamond-band",
    vendor: "Sofia Collection",
    title: "18 Karat Yellow Gold Deco Diamond Band",
    price: "$2,970",
    image:
      "https://sofiajewelry.com/cdn/shop/products/SC1991R_800x_f32e002a-9316-401d-bd7b-0f7d93c29b50.jpg?v=1674518557",
    href: "/product/18-karat-yellow-gold-deco-diamond-band",
  },
  {
    id: "18-karat-yellow-gold-gold-vine-diamond-band",
    vendor: "Sofia Collection",
    title: "18 Karat Yellow Gold Gold Vine Diamond Band",
    price: "$4,510",
    image:
      "https://sofiajewelry.com/cdn/shop/products/SC2018R_800x_01e2aba8-1b7f-4e97-8088-1328ba8baf08.jpg?v=1674518446",
    href: "/product/18-karat-yellow-gold-gold-vine-diamond-band",
  },
];

export const heroSlides = [
  {
    image:
      "https://sofiajewelry.com/cdn/shop/files/Sofia_Jewelry_16eebfd6-d343-43d1-8e03-e294502f9412.jpg?v=1787373103",
    label: "SHOP",
    href: "#featured",
  },
  {
    image:
      "https://sofiajewelry.com/cdn/shop/files/V3_2968bfe3-74fc-4208-aae2-fe8ce4769d8c.jpg?v=1786383811",
    label: "SHOP",
    href: "#featured",
  },
  {
    image:
      "https://sofiajewelry.com/cdn/shop/files/Sofia-Jewelry-Mill-Valley.jpg?v=1743176828",
    label: "OUR STORY",
    href: "#story",
  },
];